// frontend/src/components/FeaturesSection.js
import React from 'react';
import ukts from '../images/K33.jpg'

function FeaturesSection() {
    const handleDownload = () => {
        // Создаём ссылку на файл в папке public/documents/
        const link = document.createElement('a');
        link.href = '/documents/TechChar.pdf';
        link.download = 'TechChar.pdf';
        link.click();
    };

    return (
        <div id="features-section" className="t396" style={{ backgroundColor: '#efefef' }}>
            <div className="t396__artboard" style={{ padding: '100px 0' }}>
                <div className="t-container">
                    <div className="t-row">
                        <div className="t-col t-col_6">
                            <div className="t476__title t-title t-title_sm" style={{ fontSize: '42px' }}>
                                Установка контактной точечной сварки
                            </div>
                            <div className="t476__descr t-descr t-descr_sm" style={{ marginTop: '30px' }}>
                                <p>
                                    Наше оборудование предназначено для сварки черных, цветных металлов и их сплавов.
                                    Используется в электронной промышленности, приборостроении и металлообработке.
                                </p>
                                <p>
                                    <strong>Ключевые характеристики:</strong>
                                    <ul>
                                        <li>Производительность: до 60 сварок/мин</li>
                                        <li>Максимальный ток: 5 кА</li>
                                        <li>Режимы сварки: одно- и двухполярные, 1–8 импульсов</li>
                                        <li>Работа со сварочной головкой, карандашом и клещами</li>
                                        <li>Питание 380/220 В, средняя мощность 3,5 кВт</li>
                                    </ul>
                                </p>
                                <button
                                    onClick={handleDownload}
                                    style={{
                                        background: '#ffd014',
                                        border: 'none',
                                        borderRadius: '30px',
                                        padding: '12px 30px',
                                        fontSize: '16px',
                                        cursor: 'pointer',
                                        marginTop: '20px',
                                    }}
                                >
                                    Скачать технические характеристики
                                </button>
                            </div>
                        </div>
                        <div className="t-col t-col_5 t-offset_1">
                            {/* можно оставить пустым или добавить изображение */}
                            <div style={{ background: '#fff', borderRadius: '15px', padding: '20px', textAlign: 'center' }}>
                                <img src={ukts} alt="УКТС" style={{ maxWidth: '100%', height: 'auto' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FeaturesSection;